import { defineStore } from 'pinia';

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    text: '',
    color: '',
    visible: false,
    timeout: 3000,
  }),
  actions: {
    showSnackbar({ text, color, timeout }) {
      console.log('showSnackbar');
      this.text = text;
      this.color = color;
      this.visible = true;
      this.timeout = timeout || 3000;
    },
    hideSnackbar() {
      this.visible = false;
    },
  },
});
